/**
 * Created by dmitry on 09.04.2025
 */

const MergeTutorialHelper = {
    scrollToTarget: function (cells, f, options) {
        if (!cells || !cells.length) {
            return;
        }

        const scroll = Map2dScroller.currentScroller.getScrollView();
        const mapView = Map2d.currentMap.getMapView();
        options = Object.assign(options || {}, { allowScrollWithFocus: true });

        let target;

        if (cells.length > 1) {
            target = cc.getCenter(cells.map((cell) => mapView.getCell(cell.x, cell.y)));
        } else {
            options.visibleBox = options.visibleBox || {
                left: 0.3, right: 0.4, top: 0.15, bottom: 0.1
            };
            target = mapView.getCell(cells[0].x, cells[0].y);
        }

        scroll.runAction(new cc.Sequence(
            new cc.ScrollAction(target, options).easing(cc.easeInOut(2)),
            new cc.CallFunc(f)
        ));
    },
    
    createMinimalDialogue: function (data, items) {
        const dialogue = new MinimalDialogue({
            text: Messages.get(data.text),
            items,
            person: data.person,
            gravitate: data.gravitate,
            rects: Map2dAdviceView.listRects(data),
            overlapDuration: data.overlapDuration
        });

        const scene = cleverapps.Scenes.GetRunningScene();
        scene.addChild(dialogue);
        dialogue.display();

        return dialogue;
    },

    showOnlyControls: function (controls) {
        const visibleControls = ["map2d", ...(controls || [])];
        const hiddenControls = cleverapps.focusManager.controls.filter((control) => visibleControls.indexOf(control) === -1);

        cleverapps.focusManager.hideControlsWhileFocused(hiddenControls);
        cleverapps.focusManager.showControlsWhileFocused(visibleControls);
    },

    createAdviceStep: function (data) {
        data = cleverapps.clone({ ...MergeTutorial.Types[data.type], ...data }, true);

        let dialogue;
        let highlighters = [];

        const createDialogue = () => {
            if (!dialogue && data.abTest && data.dialogueTemplate) {
                dialogue = MergeTutorialHelper.createMinimalDialogue(data, data.dialogueTemplate);
                return;
            }

            if (!dialogue && data.text && !cleverapps.focusManager.currentWindow()) {
                dialogue = MergeTutorialHelper.createMinimalDialogue(data);
            }
        };

        const removeDialogue = () => {
            if (dialogue) {
                dialogue.remove();
                dialogue = undefined;
            }
        };

        const listMoveCells = (move) => cleverapps.unique((move.mergeCluster || []).concat(move.cells || []), Unit.GetPositionKey);

        const showSpotlight = (move) => {
            const litUnits = data.litUnits ? Map2d.currentMap.listAvailableUnits(data.litUnits) : [];
            Map2d.currentMap.getMapView().spotlight.show(listMoveCells(move).concat(litUnits), { area: data.litArea });
        };

        const addHighlighterForUnit = (unitPos) => {
            const unit = Map2d.currentMap.getUnit(unitPos.x, unitPos.y);
            const highlighter = new UnitHighlighter(Map2d.currentMap.getMapView(), unit, {
                spotlight: false,
                highlight: false,
                tutorialGround: true
            });
            highlighters.push(highlighter);
        };

        const createUnitHighlighter = (unitsPos) => {
            if (!unitsPos) {
                return;
            }

            cleverapps.shadow.show();

            unitsPos.forEach((unitPos) => {
                addHighlighterForUnit(unitPos);
            });
        };

        const updateUnitHighlighter = (move) => {
            if (!move.mergeCluster) {
                return;
            }

            highlighters.forEach((highlighter) => highlighter.unhighlight());
            highlighters = [];

            move.mergeCluster.forEach((unitPos) => {
                addHighlighterForUnit(unitPos);
            });
        };

        const removeUnitHighlighter = () => {
            cleverapps.shadow.hide();

            highlighters.forEach((highlighter) => highlighter.unhighlight());
            highlighters = [];
        };

        return new TutorialStep({
            onCheckConditions: function (options) {
                if (options.unit && !cleverapps.intersect(this.targets, options.unit, Unit.GetKey).length) {
                    return false;
                }

                if (options.click && data.fable && data.type === Map2d.MERGE) {
                    return false;
                }

                if (options.fog && !cleverapps.intersect(this.targets, options.fog).length) {
                    return false;
                }

                if (options.advice && !cleverapps.intersect(this.type, options.advice).length) {
                    return false;
                }

                if (options.move) {
                    const move = Map2d.currentMap.advice.getCurrentMove();
                    return move && move.cells[0].x === options.move.x && move.cells[0].y === options.move.y;
                }

                if (options.preferCell && !cc.pointEqualToPoint(options.preferCell, this.preferCell)) {
                    return false;
                }

                if (options.monster && this.monster !== options.monster) {
                    return false;
                }

                if (options.manualClose && !data.fable) {
                    return false;
                }

                if (options.toolbarItem) {
                    return false;
                }

                return true;
            },

            onStart: function () {
                this.type = data.type;
                this.targets = data.targets = cleverapps.toArray(data.targets) || [];
                this.preferCell = data.preferCell;
                this.monster = data.monster;
                this.strictInput = Boolean(data.fable);
                this.listTargetRects = () => (Map2d.currentMap ? Map2dAdviceView.listRects(data) : []);

                Map2d.currentMap.advice.setLogic(data.type, data);

                if (!Map2d.currentMap.advice.hasHints()) {
                    this.finish();
                    return;
                }

                const move = Map2d.currentMap.advice.findMove();

                console.log("tutorial advice step", data.type, !!move);

                if (!move) {
                    this.finish();
                    return;
                }

                const actions = [
                    function (f) {
                        if (data.noScroll) {
                            f();
                            return;
                        }
                        MergeTutorialHelper.scrollToTarget(move.mergeCluster || [move.cells[0]], f, data.scroll);
                    },

                    function (f) {
                        cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);

                        MergeTutorialHelper.showOnlyControls(data.controls);

                        let fingerDelay = data.fingerDelay === undefined ? MergeTutorial.FINGER_DELAY : data.fingerDelay;

                        if (data.abTest && data.abTestFingerDelay !== undefined) {
                            fingerDelay = data.abTestFingerDelay;
                        }

                        let arrowConfig = {
                            delay: data.arrowDelay === undefined ? MergeTutorial.ARROW_DELAY : data.arrowDelay
                        };

                        if (data.abTest) {
                            if (data.noArrow) {
                                arrowConfig = false;
                            } else if (data.arrowType) {
                                arrowConfig.arrowType = data.arrowType;
                            }
                        }

                        Map2d.currentMap.advice.startHint({
                            highlight: data.highlight,
                            highlightMerge: data.highlightMerge,
                            arrow: arrowConfig,
                            finger: {
                                delay: fingerDelay,
                                repeatDelay: 2
                            }
                        });

                        const unit = Map2d.currentMap.getUnit(move.cells[0].x, move.cells[0].y);
                        if (data.lovesInfoView && unit && !InfoView.IsDisplayedFor(unit)) {
                            InfoView.DisplayInfo(unit);
                        }

                        if (data.recipeCookingDuration !== undefined && unit) {
                            const customer = unit.findComponent(Customer);
                            if (customer && customer.recipe) {
                                customer.recipe.setCookingDuration(data.recipeCookingDuration);
                            }
                        }

                        if (data.order !== undefined && unit) {
                            const customer = unit.findComponent(Customer);
                            if (customer && !customer.recipe) {
                                customer.order();
                            }
                        }

                        cleverapps.eventBus.on("window_shown", removeDialogue, this);
                        Map2d.currentMap.customers.on("selectedCustomerChanged", removeDialogue, this);
                        cleverapps.eventBus.on("closeWindows", createDialogue, this);

                        createDialogue();

                        if (data.fable) {
                            showSpotlight(move);
                            Map2d.currentMap.advice.on("showHint", showSpotlight, this);
                        } else if (data.abTest && data.specialMergeEffects && this.type === Map2d.MERGE) {
                            createUnitHighlighter(move.mergeCluster);
                            Map2d.currentMap.advice.on("showHint", updateUnitHighlighter, this);
                        }

                        const callback = (options = {}) => {
                            console.log("tutorial advice event", data.type);

                            if (data.allMoves && Map2d.currentMap.advice.findMove()) {
                                return;
                            }

                            if (data.type !== Map2d.START_MINING && data.prizes && !Unit.Equals(options.unit, data.prizes)) {
                                return;
                            }

                            if (data.instantMining) {
                                const worker = Map2d.currentMap.workers.findAssigned(options.unit);
                                if (worker) {
                                    worker.duration = 0;
                                    if (worker.timeout) {
                                        worker.clearTimeout();
                                        worker.startWorking();
                                    }
                                    Map2d.currentMap.workers.save();
                                }
                            }

                            const nextStepDelay = data.nextStepDelay * 1000 || 0;
                            if (nextStepDelay) {
                                Map2dLocation.currentLocation.counter.setTimeout(() => {}, nextStepDelay);
                            }

                            f();
                        };

                        (data.types || [data.type]).forEach((type) => {
                            cleverapps.tutorial.on(type, callback, this);
                        });
                    }.bind(this)
                ];

                if (data.fable) {
                    cleverapps.focusManager.setEventNodes([]);
                    actions[0](() => actions[1](cleverapps.once(this.finish.bind(this))));
                } else {
                    cleverapps.focusManager.compound(this.finish.bind(this), actions);
                }
            },

            onFinish: function () {
                Map2d.currentMap.advice.stopHint();
                removeDialogue();

                if (data.fable) {
                    Map2d.currentMap.getMapView().spotlight.hide();
                } else if (data.abTest && data.specialMergeEffects && this.type === Map2d.MERGE) {
                    removeUnitHighlighter();
                }

                Map2dLocation.currentLocation.counter.trigger();
            }
        });
    },

    createGuideWindowStep: function (data) {
        return new TutorialStep({
            onStart: function () {
                if (!data.bundle) {
                    this.finish();
                    return;
                }

                new GuideWindow(data);
                cleverapps.focusManager.onceNoWindowsListener = () => this.finish();
            },

            onFinish: function () {
                Map2dLocation.currentLocation.counter.trigger();
            }
        });
    },

    createUnlockFogStep: function (data) {
        return new TutorialStep({
            onStart: function () {
                if (Map2dLocation.currentLocation.map.fogs.blocks[data.id]) {
                    Map2dLocation.currentLocation.map.fogs.blocks[data.id].unlock(() => {
                        const nextStepDelay = data.nextStepDelay * 1000 || 0;
                        if (nextStepDelay) {
                            Map2dLocation.currentLocation.counter.setTimeout(() => {}, nextStepDelay);
                        }

                        this.finish();
                    }, data.silent);
                } else {
                    this.finish();
                }
            },

            onFinish: function () {
                Map2dLocation.currentLocation.counter.trigger();
            }
        });
    }
};
